import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\ActivityLog\FetchActivityLogsByDayController::__invoke
* @see app/Http/Controllers/ActivityLog/FetchActivityLogsByDayController.php
* @route '/api/activity/by-day'
*/
const FetchActivityLogsByDayController = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: FetchActivityLogsByDayController.url(options),
    method: 'get',
})

FetchActivityLogsByDayController.definition = {
    methods: ["get","head"],
    url: '/api/activity/by-day',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\ActivityLog\FetchActivityLogsByDayController::__invoke
* @see app/Http/Controllers/ActivityLog/FetchActivityLogsByDayController.php
* @route '/api/activity/by-day'
*/
FetchActivityLogsByDayController.url = (options?: RouteQueryOptions) => {
    return FetchActivityLogsByDayController.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\ActivityLog\FetchActivityLogsByDayController::__invoke
* @see app/Http/Controllers/ActivityLog/FetchActivityLogsByDayController.php
* @route '/api/activity/by-day'
*/
FetchActivityLogsByDayController.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: FetchActivityLogsByDayController.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\ActivityLog\FetchActivityLogsByDayController::__invoke
* @see app/Http/Controllers/ActivityLog/FetchActivityLogsByDayController.php
* @route '/api/activity/by-day'
*/
FetchActivityLogsByDayController.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: FetchActivityLogsByDayController.url(options),
    method: 'head',
})

export default FetchActivityLogsByDayController